module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA7UlEQVQ4T73VSwrCMBAG4JmYuBcEvYDoGRS8hA8QV4Kb3sFFwTtoXCioiO2xFLppe4dIlKDU1kxKsbuS8mUmZP4iZJ74IjvA4MhqatKcelF23faO2Q/Sq1wrhBUA3JGpviv6BeoN4kAeEGChUS74sDFa3myVmfVcUCmFSbjbv1AVcSEGVDQX1LuVRQvBsuhP0KBpKM8AOKe0bwWfqO+ztNc6UVAS6IKSQYMm3XaICOOi9p1BW+tkkHqOJJCK6WOxgvqCV3ZtykzL/0bvnTgVhEMSbDcA6FFGLRtrPwLWrbLCPDS/AFHnM2oGflb5AIocpRW9HdUaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goods/qianjin.png
// module id = DPHR
// module chunks = 0